import { useEffect, useState } from "react";
import { KEY_REMEMBER_EMAIL } from "../constants";

type UseRememberedEmailOps = {
  set: (email: string) => void,
  clear: () => void,
  update: (shouldSet: boolean, newEmail: string) => void
}

type UseRememberedEmail = () => [
  string,
  boolean,
  UseRememberedEmailOps
]

export const useRememberedEmail: UseRememberedEmail = () => {
  const [remembered, setRemembered] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const storedEmail = localStorage.getItem(KEY_REMEMBER_EMAIL);
    setEmail(storedEmail ?? "");
    setRemembered(storedEmail !== null);
  }, []);

  const clear: UseRememberedEmailOps["clear"] = () => {
    localStorage.removeItem(KEY_REMEMBER_EMAIL);
  };

  const set: UseRememberedEmailOps["set"] = (newEmail) => {
    localStorage.setItem(KEY_REMEMBER_EMAIL, newEmail);
  };

  const update: UseRememberedEmailOps["update"] = (shouldSet: boolean, newEmail: string) => {
    if (shouldSet) set(newEmail);
    else clear();
  };

  return [email, remembered, { set, clear, update }];
};
